"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "isTargetStatusLogEntry", {
    enumerable: true,
    get: function() {
        return isTargetStatusLogEntry;
    }
});
function isTargetStatusLogEntry(data) {
    return data !== undefined && data.target && data.status !== undefined;
}
